angular.module('qkr').factory('countryService', ($http, $q, appConfig) => ({

        listCountries: () => {
            const deferred = $q.defer();

            $http.get(appConfig.apiUrl + 'country/list', {withCredentials: true})
                .then((response) => deferred.resolve(response.data),
                    (reason) => deferred.reject(reason.data));

            return deferred.promise;
        }

    }));



// WEBPACK FOOTER //
// ./src/services/country.services.js